import { fetchData } from '../../../Foundation/Utils/fetchData';

const getArticlesByAuthorId = (params) => {
  const url = 'amica/api/blog/search?' + new URLSearchParams(params);
  return fetchData(url);
};

export default { getArticlesByAuthorId };
